import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HelpersService } from '../../core/services/helpers.service';
import { NetworkCallService } from '../../core/services/network-call.service';
import { GoogleMapsKeyService } from '../google-maps-key-service';
import { of, from } from 'rxjs';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import * as googleAPIKeyActions from '../actions/google-api-key.actions';
import { IGoogleAPIKeyRequest, IGoogleAPIKeyResponse } from '../models/google-api-key.model';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class StaticDataGoogleAPIKeyEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private googleMapsKeyService: GoogleMapsKeyService,
    private helpers: HelpersService
  ) {}

  loadGoogleAPIKey$ = createEffect(() =>
    this.actions$.pipe(
      ofType(googleAPIKeyActions.loadGoogleAPIKey),
      switchMap(() =>
        from(this.googleMapsKeyService.getPublicKeyBase64()).pipe(
          mergeMap(publicKeyBase64 => {
            const request: IGoogleAPIKeyRequest = {
              publicKey: publicKeyBase64
            };

            return this.networkCallService.post<IGoogleAPIKeyRequest, IGoogleAPIKeyResponse>(
              'StaticData/GoogleAPIKey',
              request,
              { params: new HttpParams().set('noLoader', 'true') }
            ).pipe(
              map(response => {
                if (!response || !response.encryptedData) {
                  throw new Error('Invalid response from API: missing encryptedData');
                }
                // Store encrypted data without decrypting - decryption will happen in components
                return googleAPIKeyActions.loadGoogleAPIKeySuccess({ encryptedData: response.encryptedData });
              }),
              catchError(error => {
                return of(googleAPIKeyActions.loadGoogleAPIKeyFailure({ error }));
              })
            );
          }),
          catchError(error => {
            return of(googleAPIKeyActions.loadGoogleAPIKeyFailure({ error }));
          })
        )
      )
    )
  );
}

